import { render, staticRenderFns } from "./Resposta.vue?vue&type=template&id=022c5a2c&scoped=true&"
import script from "./Resposta.vue?vue&type=script&lang=js&"
export * from "./Resposta.vue?vue&type=script&lang=js&"
import style0 from "./Resposta.vue?vue&type=style&index=0&id=022c5a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c5a2c",
  null
  
)

export default component.exports